module.exports = __webpack_public_path__ + "img/carshinaused_12.fabade88.jpg";